import { useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

/**
 * "Teslim Fotoğrafı" lazy-loaded button. Renders a compact card that fetches
 * the actual base64 image only when the user taps it (and then opens the
 * fullscreen preview).
 */
export function DeliveryPhotoButton({ orderId, hasDeliveryImage, onPreview, testId }) {
  const [src, setSrc] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!hasDeliveryImage) return null;

  const handleClick = async () => {
    if (src) { onPreview?.(src); return; }
    setLoading(true);
    try {
      const { data } = await api.get(`/orders/${orderId}/delivery-image`);
      setSrc(data.delivery_image_url);
      onPreview?.(data.delivery_image_url);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handleClick}
      disabled={loading}
      className="mt-3 flex items-center gap-3 border-2 border-emerald-300 bg-emerald-50 p-2 hover:border-emerald-500 transition-colors w-full text-left disabled:opacity-60"
    >
      <div className="w-14 h-14 border border-emerald-300 bg-white flex items-center justify-center shrink-0 overflow-hidden">
        {src ? (
          <img src={src} alt="Teslim" className="w-full h-full object-cover" />
        ) : loading ? (
          <Loader2 size={20} className="animate-spin text-emerald-700" />
        ) : (
          <Camera size={22} strokeWidth={2} className="text-emerald-700" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <Camera size={11} strokeWidth={2.5} className="text-emerald-800" />
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-emerald-800">Teslim Fotoğrafı</span>
        </div>
        <div className="text-[11px] text-emerald-700 mt-0.5">
          {src ? "Görüntülemek için tıkla" : loading ? "Yükleniyor…" : "Fotoğrafı yükle ve görüntüle"}
        </div>
      </div>
    </button>
  );
}
